const loadPath = (languages, namespaces) => {

  if (languages[0] === 'ja') {
    return '<%= ActionController::Base.helpers.asset_path("ja/translation.json") %>';
  }
  
  return undefined;
};

export default loadPath;